<template>
  <div
    :class="'rt-picklist ' + (iconSrc ? 'hasprefixicon' : '')"
    @mouseenter="inputHovering = true"
    @mouseleave="inputHovering = false"
  >
    <rt-icon
      v-show="iconSrc"
      :img-src="iconSrc"
      :class="{ prefixicon: iconSrc }"
    />
    <el-select
      v-model="selectedValue"
      :disabled="disabled"
      :multiple="multiple"
      :filterable="filterable"
      :size="size"
      clearable
      popper-class="rt-picklist-popper"
      @change="handleChange"
    >
      <el-option
        v-for="item in options"
        :key="item[valueKey]"
        :label="item[nameKey]"
        :value="item[valueKey]"
        :disabled="item.disabled"
      >
        <rt-icon v-if="item.IconSrc" :img-src="item.IconSrc" />
        {{ item[nameKey] }}
      </el-option>
    </el-select>
    <rt-icon v-show="!showClose && !disabled" name="rt-base-dropdown" />
    <rt-icon v-if="showClose" name="rt-base-close" @click="clear" />
  </div>
</template>
<script type="text/javascript">
import RtIcon from '../icon/rtIcon';
const DEFAULT_KEYS = {
  value: 'Value',
  name: 'Text'
};
export default {
  name: 'RtPicklist',
  components: {
    RtIcon
  },
  props: {
    fetch: {
      type: Function,
      default: null,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    params: {
      type: Object,
      default: null
    },
    entity: {
      type: String
    },
    attribute: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    alias: {
      type: Object,
      default() {
        return {};
      }
    },
    displayValue: {
      type: Array,
      default() {
        return [];
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default() {
        return 'mini';
      }
    }
  },
  data() {
    return {
      selectedValue: null,
      options: [],
      inputHovering: false,
      allOptions: []
    };
  },
  computed: {
    valueKey() {
      return this.alias.value || DEFAULT_KEYS.value;
    },
    nameKey() {
      return this.alias.name || DEFAULT_KEYS.name;
    },
    showClose() {
      return this.selectedValue != null && this.inputHovering && !this.disabled;
    },
    iconSrc() {
      if (this.options && this.selectedValue) {
        var item = this.options.filter(
          p => p[this.valueKey] == this.selectedValue
        );
        if (item && item.length > 0) {
          //显示icon图标
          if (item[0].IconSrc) {
            return item[0].IconSrc;
          } else {
            return null;
          }
        }
      }
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    },
    displayValue(newVal, oldVal) {
      this.setOptions();
    },
    attribute(newValue, oldValue) {
      if (newValue != oldValue) {
        this.bindPicklist();
      }
    }
  },
  mounted() {
    this.bindPicklist();
  },
  methods: {
    bindPicklist() {
      if (this.fetch) {
        this.fetch()
          .then(res => {
            this.options = res;
          })
          .catch(error => {
            rt.showErrorToast(error.message);
          });
      } else {
        let { params, entity, attribute } = this;
        params = Object.assign({}, params, { entity, attribute });
        this.$picklist
          .getPicklistData(params)
          .then(res => {
            res.map(item => {
              if (item.IconSrc) {
                item.IconSrc = this.getBaseUrl() + item.IconSrc;
              }
            });
            this.allOptions = res;
            this.setOptions();
          })
          .catch(error => {
            rt.showErrorToast(error.message);
          });
      }
      if (this.value || this.value === 0) {
        this.selectedValue = this.value;
      }
    },
    setOptions() {
      if (this.allOptions.length == 0) {
        this.options = [];
        return;
      }
      var _options = this.allOptions;
      if (this.displayValue != null && this.displayValue.length > 0) {
        _options = this.allOptions.filter(
          p => this.displayValue.indexOf(p[this.valueKey]) >= 0
        );
        //赋值之前判断是否存在选项集中
        if (this.selectedValue) {
          var selectedValues = _options.filter(
            p => p[this.valueKey] == this.selectedValue
          );
          if (selectedValues == null || selectedValues.length == 0) {
            this.$emit('input', null);
            this.$emit('change', null);
          }
        }
      }
      this.options = _options;
    },
    handleChange(val) {
      this.$emit('input', val);

      this.$emit('change', val);
    },
    clear() {
      this.handleChange(null);
    },
    getBaseUrl() {
      var baseUrl = '';
      if (process.env.NODE_ENV === 'production') {
        baseUrl = window.location.origin;
      } else {
        baseUrl = localStorage.serverAddress;
      }
      if (!baseUrl.endWith('/')) {
        baseUrl += '/';
      }

      return baseUrl;
    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?779a6a9e